export const d001 = {
  json: {
    name: 'body',
    type: 'body',
    active: true,
    dropDown: true,
    editable: true,
    innerText: '',
    styles: {
      fontFamily: 'Ubuntu',
      marginLeft: '-2px',
      margin: '',
      width: '',
      color: 'rgba(0,0,0,1)',
      borderStyle: 'none',
    },
    childrens: [
      {
        type: 'block',
        active: false,
        editable: true,
        styles: {
          flexDirection: 'row',
          height: '100vh',
          width: '100%',
        },
        childrens: [
          {
            type: 'block',
            active: false,
            editable: true,
            styles: {
              height: '100%',
              backgroundImage:
                'url(https://snapshotstore.fra1.digitaloceanspaces.com/Mc8kW4x9Q3aRR3RkP5Im_IMG_4417.-30339)',
              backgroundSize: 'cover',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '26px',
              width: '50%',
            },
            childrens: [
              {
                type: 'heading',
                active: false,
                editable: true,
                innerText: 'SIGN UP',
                styles: {
                  color: 'rgba(255,255,255,1)',
                  fontSize: '32px',
                  fontWeight: '600',
                },
              },
              {
                type: 'paragraph',
                active: false,
                editable: true,
                innerText:
                  'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form',
                styles: {
                  color: 'rgba(255,255,255,1)',
                  textAlign: 'center',
                },
              },
            ],
            dropDown: true,
          },
          {
            type: 'block',
            active: true,
            editable: true,
            styles: {
              height: '100%',
              padding: '26px',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              width: '50%',
            },
            childrens: [
              {
                type: 'block',
                active: false,
                editable: true,
                styles: {
                  borderRadius: '12px',
                  borderStyle: 'solid',
                  borderWidth: '1px',
                  borderColor: 'rgba(0,0,0,0.2)',
                  width: '80%',
                  paddingTop: '26px',
                  paddingBottom: '26px',
                  paddingLeft: '24px',
                  paddingRight: '24px',
                },
                childrens: [
                  {
                    type: 'heading',
                    active: false,
                    editable: true,
                    innerText: 'Create An Account',
                    styles: {
                      fontWeight: '600',
                      fontSize: '24px',
                      marginLeft: '',
                      marginTop: '',
                      marginBottom: '22px',
                      padding: '10px',
                    },
                  },
                  {
                    type: 'form',
                    active: false,
                    editable: true,
                    styles: {
                      padding: '10px',
                    },
                    submitAction: 'createPass',
                    childrens: [
                      {
                        type: 'block',
                        active: false,
                        editable: true,
                        childrens: [
                          {
                            type: 'label',
                            active: false,
                            editable: true,
                            innerText: 'Email',
                            htmlFor: 'email',
                            styles: {
                              fontSize: '14px',
                              paddingLeft: '6px',
                              marginBottom: '3px',
                            },
                          },
                          {
                            type: 'input',
                            active: false,
                            editable: true,
                            value: '',
                            inputName: 'email',
                            id: 'email',
                            name: 'email',
                            inputType: 'email',
                            placeholder: 'Enter your email',
                            required: true,
                            styles: {
                              borderRadius: '8px',
                              fontSize: '16px',
                              paddingLeft: '16px',
                              paddingRight: '16px',
                              borderStyle: 'solid',
                              borderWidth: '1px',
                              borderColor: 'rgba(0,0,0,0.36)',
                              paddingTop: '6px',
                              paddingBottom: '6px',
                            },
                          },
                        ],
                        dropDown: true,
                      },
                      {
                        type: 'block',
                        active: false,
                        editable: true,
                        childrens: [
                          {
                            type: 'label',
                            active: false,
                            editable: true,
                            innerText: 'Phone',
                            htmlFor: 'email',
                            styles: {
                              fontSize: '14px',
                              paddingLeft: '6px',
                              marginBottom: '3px',
                            },
                          },
                          {
                            type: 'input',
                            active: false,
                            editable: true,
                            value: '',
                            inputName: 'phone',
                            id: 'email',
                            name: 'email',
                            inputType: 'text',
                            placeholder: 'Enter your phone',
                            required: true,
                            styles: {
                              borderRadius: '8px',
                              fontSize: '16px',
                              paddingLeft: '16px',
                              paddingRight: '16px',
                              borderStyle: 'solid',
                              borderWidth: '1px',
                              borderColor: 'rgba(0,0,0,0.36)',
                              paddingTop: '6px',
                              paddingBottom: '6px',
                            },
                          },
                        ],
                        dropDown: true,
                        styles: {
                          marginTop: '16px',
                        },
                      },
                      {
                        type: 'block',
                        active: false,
                        editable: true,
                        styles: {
                          marginTop: '16px',
                          marginLeft: '-10px',
                          marginRight: '-10px',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                        },
                        childrens: [
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            childrens: [
                              {
                                type: 'label',
                                active: false,
                                editable: true,
                                innerText: 'Password',
                                htmlFor: 'email',
                                styles: {
                                  fontSize: '14px',
                                  paddingLeft: '6px',
                                  marginBottom: '3px',
                                },
                              },
                              {
                                type: 'input',
                                active: false,
                                editable: true,
                                value: '',
                                inputName: 'password',
                                id: 'email',
                                name: 'email',
                                inputType: 'password',
                                placeholder: 'Enter your password',
                                required: true,
                                styles: {
                                  borderRadius: '8px',
                                  fontSize: '16px',
                                  paddingLeft: '16px',
                                  paddingRight: '16px',
                                  borderStyle: 'solid',
                                  borderWidth: '1px',
                                  borderColor: 'rgba(0,0,0,0.36)',
                                  paddingTop: '6px',
                                  paddingBottom: '6px',
                                },
                              },
                            ],
                            dropDown: true,
                            styles: {
                              marginTop: '',
                              paddingLeft: '10px',
                              paddingRight: '10px',
                              width: '50%',
                            },
                          },
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            childrens: [
                              {
                                type: 'label',
                                active: false,
                                editable: true,
                                innerText: 'Confirm Password',
                                htmlFor: 'email',
                                styles: {
                                  fontSize: '14px',
                                  paddingLeft: '6px',
                                  marginBottom: '3px',
                                },
                              },
                              {
                                type: 'input',
                                active: false,
                                editable: true,
                                value: '',
                                inputName: 'confirmPassword',
                                id: 'email',
                                name: 'email',
                                inputType: 'password',
                                placeholder: 'Confirm your password',
                                required: true,
                                styles: {
                                  borderRadius: '8px',
                                  fontSize: '16px',
                                  paddingLeft: '16px',
                                  paddingRight: '16px',
                                  borderStyle: 'solid',
                                  borderWidth: '1px',
                                  borderColor: 'rgba(0,0,0,0.36)',
                                  paddingTop: '6px',
                                  paddingBottom: '6px',
                                },
                              },
                            ],
                            dropDown: true,
                            styles: {
                              marginTop: '',
                              paddingLeft: '10px',
                              paddingRight: '10px',
                              width: '50%',
                            },
                          },
                        ],
                        dropDown: true,
                      },
                      {
                        type: 'button',
                        active: false,
                        editable: true,
                        styles: {
                          marginTop: '28px',
                          paddingLeft: '20px',
                          paddingRight: '20px',
                          fontSize: '14px',
                          color: 'rgba(252,252,253,1)',
                          backgroundColor: 'rgba(69,37,231,1)',
                          borderRadius: '8px',
                          width: '',
                          paddingTop: '10px',
                          paddingBottom: '10px',
                          fontWeight: '500',
                        },
                        elementType: 'submit',
                        innerText: 'Submit',
                      },
                    ],
                    dropDown: true,
                  },
                ],
                dropDown: true,
              },
            ],
            dropDown: true,
          },
        ],
        dropDown: true,
      },
    ],
  },
  html: '<link href="https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,100;0,300;0,400;0,500;0,700;1,100;1,300;1,400;1,500;1,700&amp;display=swap" rel="stylesheet"><div class="body focused" style="font-family: Ubuntu; color: rgb(0, 0, 0); border-style: none;"><div class="block cd false false" style="flex-direction: row; height: 100vh; width: 100%;"><div class="block cd false" style="height: 100%; background-image: url(&quot;https://snapshotstore.fra1.digitaloceanspaces.com/Mc8kW4x9Q3aRR3RkP5Im_IMG_4417.-30339&quot;); background-size: cover; flex-direction: column; align-items: center; justify-content: center; padding: 26px; width: 50%;"><div class="element cd false" contenteditable="false" style="color: rgb(255, 255, 255); font-size: 32px; font-weight: 600;">SIGN UP</div><div class="element cd false" contenteditable="false" style="color: rgb(255, 255, 255); text-align: center;">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</div></div><div class="block cd false focused" style="height: 100%; padding: 26px; flex-direction: row; align-items: center; justify-content: center; width: 50%;"><div class="block cd false" style="border-radius: 12px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.2); width: 80%; padding: 26px 24px;"><div class="element cd false" contenteditable="false" style="font-weight: 600; font-size: 24px; margin-bottom: 22px; padding: 10px;">Create An Account</div><form id="createPass" class="element cd false" style="padding: 10px;"><div class="block cd false false"><label class="element cd false" contenteditable="false" for="email" style="font-size: 14px; padding-left: 6px; margin-bottom: 3px;">Email</label><input class="element cd false" name="email" id="email" placeholder="Enter your email" type="email" required="" value="" style="border-radius: 8px; font-size: 16px; padding: 6px 16px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.36);"></div><div class="block cd false false" style="margin-top: 16px;"><label class="element cd false" contenteditable="false" for="email" style="font-size: 14px; padding-left: 6px; margin-bottom: 3px;">Phone</label><input class="element cd false" name="phone" id="email" placeholder="Enter your phone" type="text" required="" value="" style="border-radius: 8px; font-size: 16px; padding: 6px 16px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.36);"></div><div class="block cd false false" style="margin-top: 16px; margin-left: -10px; margin-right: -10px; flex-direction: row; align-items: center; justify-content: center;"><div class="block cd false" style="padding-left: 10px; padding-right: 10px; width: 50%;"><label class="element cd false" contenteditable="false" for="email" style="font-size: 14px; padding-left: 6px; margin-bottom: 3px;">Password</label><input class="element cd false" name="password" id="email" placeholder="Enter your password" type="password" required="" value="" style="border-radius: 8px; font-size: 16px; padding: 6px 16px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.36);"></div><div class="block cd false false" style="padding-left: 10px; padding-right: 10px; width: 50%;"><label class="element cd false" contenteditable="false" for="email" style="font-size: 14px; padding-left: 6px; margin-bottom: 3px;">Confirm Password</label><input class="element cd false" name="confirmPassword" id="email" placeholder="Confirm your password" type="password" required="" value="" style="border-radius: 8px; font-size: 16px; padding: 6px 16px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.36);"></div></div><button class="element cd false" contenteditable="false" type="submit" style="margin-top: 28px; padding: 10px 20px; font-size: 14px; color: rgb(252, 252, 253); background-color: rgb(69, 37, 231); border-radius: 8px; font-weight: 500;">Submit</button></form></div></div></div></div>',
}
